<template>
  <el-card :body-style="{ padding: '0px'}" class="carder">
    <el-row class="carder-title">
<!--      <el-col :span="1">-->
<!--        <el-tooltip :content="item.isFree===0?'有条件开放':'无条件开放'">-->
<!--          <svg-icon :iconClass="item.isFree===0?'lock':'unlock'"></svg-icon>-->
<!--        </el-tooltip>-->
<!--      </el-col>-->
      <el-col :span="24" style="cursor:pointer" @click.native="handleClick">{{ item.fileTitle }}</el-col>
    </el-row>
    <div class="carder-content">
      <el-row>
        <el-col :span="6" class="info-item">省份：{{ item.province }}</el-col>
        <el-col :span="6" class="info-item">城市：{{ item.city }}</el-col>
        <el-col :span="6" class="info-item">部门：{{ item.department }}</el-col>
        <el-col :span="6" class="info-item">访问量：{{ item.viewCnt }} 次</el-col>
<!--        <el-col :span="6" class="info-item">主题：{{ item.subject }} </el-col>-->
<!--        <el-col :span="6" class="info-item">采集时间：{{ item.year }} </el-col>-->
      </el-row>
      <!-- <el-row>
        <time class="carder-summary">描述：{{ item.fileTitle }}</time>
      </el-row> -->
      <div class="bottom">
        <el-row>
          <el-col :span="20">
            <el-tag v-for="tag in tags" :key="tag" :color="colors[tag]" effect="dark" size="medium">{{ tag }}</el-tag>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="mini" @click.native="handleClick" style="background-color: #76be69; border-color: #76be69;">查看详情<i class="el-icon-arrow-right el-icon--right"></i></el-button>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-card>
</template>

<script>
import SvgIcon from './SvgIcon.vue'
export default {
  components: { SvgIcon },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      value: 4.5,
      colors: {
        'json': '#dadf00',
        'xml': '#0b4442',
        'csv': '#006f6f',
        'xls': '#009844',
        'xlsx': '#49ab35',
        'pdf': '#76be69',
        'doc': '#0b4442',
        'docx': '#006f6f',
        'rdf': '#009844',
        'zip': '#49ab35',
        'rar': '#0b4442'
      }
    }
  },
  methods: {
    handleClick () {
      this.$emit('router-to')
    },
    formatDate (ts) {
      let td = new Date(ts)
      let month = '' + (td.getMonth() + 1)
      let day = '' + td.getDate()
      let year = '' + td.getUTCFullYear()
      let hour = '' + td.getHours()
      let min = '' + td.getMinutes()
      let sec = '' + td.getSeconds()
      if (month.length < 2) {
        month = '0' + month
      }
      if (day.length < 2) {
        day = '0' + day
      }
      if (hour.length < 2) {
        hour = '0' + hour
      }
      if (min.length < 2) {
        min = '0' + min
      }
      if (sec.length < 2) {
        sec = '0' + sec
      }
      return [year, month, day].join('-') + ' ' + [hour, min, sec].join(':')
    }
  }
}
</script>

<style scoped>
.carder {
  margin-top: 20px;
  padding: 10px 0 0 0;
  font-family: '微软雅黑';
}

.carder-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.6;
  margin-bottom: 4px;
  padding: 5px 20px;
  display: flex;
  justify-content: space-between;
}

.carder-summary {
  font-size: 12px;
  line-height: 26px;
  color: #999;
}

.carder-operation {
  padding: 0;
  float: right;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.bottom .el-tag{
  margin-right: 5px;
  border-style: none;
}

.carder-content {
  background: #f5f5f5;
  padding: 10px 20px 20px 20px;
}

.carder-content .info-item {
  font-size: 12px;
  line-height: 26px;
}

</style>



// WEBPACK FOOTER //
// src/pages/common/Carder.vue